module.exports = __webpack_public_path__ + "img/1511253430.34819d32.jpg";